import { useState, useEffect } from 'react';
import { TempleConfigContext } from './TempleConfigContext';
import { getApi, postApi } from '../ApiServices/api';
import { apiEndPoints } from '../ApiServices/config';

const LOCAL_STORAGE_KEY = 'temple_config';
const CACHE_TTL = 1000 * 60 * 60; // 1 hour

export const TempleConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  const fetchConfig = async () => {
    try {
      const response = await getApi(apiEndPoints?.getTempleConfig);
      if (response && response.status === 200) {
        const newConfig = {
          priest: response?.data?.data?.priestconfig?.sval,
          rental_flow: response?.data?.data?.rentalConfig?.sval,
          service_outside_temple_flow: response?.data?.data?.serviceOutsideTempleConfig?.sval,
          catering_advance_type: response?.data?.data?.cateringAdvancePaymentType?.sval,
          catering_advance_payment: response?.data?.data?.cateringAdvancePayment?.sval,
          priest_hourly_charges: response?.data?.data?.priestHourlyCharges?.sval,
          puja_attendees_capacity: response?.data?.data?.puja_attendees_capacity?.sval,
          slot_config: response?.data?.data?.slot_config?.sval,
          catering_config: response?.data?.data?.catering_config?.sval,
          personal_service_temple_config: response?.data?.data?.personalServiceTempleConfig?.sval,
          payment_mode: response?.data?.data?.paymentMode?.sval
        };
        // Cache config with timestamp
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ data: newConfig, timestamp: Date.now() }));

        setConfig(newConfig);
      } else {
        // localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ data: newConfig, timestamp: Date.now() }));
        setConfig(null);
      }
    } catch (error) {
      setConfig(null);
      console.error('Error fetching temple config:', error);
    }
  };

  useEffect(() => {
    const cached = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (cached) {
      try {
        const parsed = JSON.parse(cached);
        if (parsed.timestamp && Date.now() - parsed.timestamp < CACHE_TTL) {
          setConfig(parsed.data);
          return; // ✅ Stop here, don't re-fetch
        } else {
          localStorage.removeItem(LOCAL_STORAGE_KEY); // expired
        }
      } catch (err) {
        localStorage.removeItem(LOCAL_STORAGE_KEY); // corrupted
      }
    }

    fetchConfig();

    // 🧹 Cleanup on unload
    const handleUnload = () => {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    };

    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  return <TempleConfigContext.Provider value={{ config }}>{children}</TempleConfigContext.Provider>;
};
